/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListForumCategories200ResponseDataInner
 */
export interface ListForumCategories200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof ListForumCategories200ResponseDataInner
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ListForumCategories200ResponseDataInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumCategories200ResponseDataInner
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumCategories200ResponseDataInner
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ListForumCategories200ResponseDataInner
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof ListForumCategories200ResponseDataInner
     */
    threadCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ListForumCategories200ResponseDataInner
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumCategories200ResponseDataInner
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ListForumCategories200ResponseDataInner interface.
 */
export function instanceOfListForumCategories200ResponseDataInner(value: object): value is ListForumCategories200ResponseDataInner {
    return true;
}

export function ListForumCategories200ResponseDataInnerFromJSON(json: any): ListForumCategories200ResponseDataInner {
    return ListForumCategories200ResponseDataInnerFromJSONTyped(json, false);
}

export function ListForumCategories200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListForumCategories200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'description': json['description'] == null ? undefined : json['description'],
        'position': json['position'] == null ? undefined : json['position'],
        'threadCount': json['thread_count'] == null ? undefined : json['thread_count'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ListForumCategories200ResponseDataInnerToJSON(json: any): ListForumCategories200ResponseDataInner {
    return ListForumCategories200ResponseDataInnerToJSONTyped(json, false);
}

export function ListForumCategories200ResponseDataInnerToJSONTyped(value?: ListForumCategories200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slug': value['slug'],
        'description': value['description'],
        'position': value['position'],
        'thread_count': value['threadCount'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

